import checkInputs from "utils/checkInputs";

export const validationPartner = {
  addUser: function validationAddUser(newUser) {
    const errors = {};

    if (!checkInputs.notNull(newUser.identificacionUsuario)) {
      errors.identificacionUsuario = "Ingrese la identificación del usuario.";
    } else if (!checkInputs.isAlphanumeric(newUser.identificacionUsuario)) {
      errors.identificacionUsuario =
        "No puede contener caracteres especiales, solo letras o números.";
    } else if (newUser.identificacionUsuario.length > 300) {
      errors.identificacionUsuario = "No ingrese más de 300 caracteres.";
    }

    if (!checkInputs.notNull(newUser.correoPrincipalUsuario)) {
      errors.correoPrincipalUsuario = "El correo del usuario es necesario.";
    } else if (!checkInputs.notNull(newUser.correoPrincipalUsuario)) {
      errors.correoPrincipalUsuario = "El correo del usuario es necesario.";
    } else if (!checkInputs.validationEmail(newUser.correoPrincipalUsuario)) {
      errors.correoPrincipalUsuario =
        "El correo del usuario es erróneo. Ingrese un correo con el formato user@ejemplo.com";
    } else if (newUser.correoPrincipalUsuario.length > 300) {
      errors.correoPrincipalUsuario = "No ingrese más de 300 caracteres.";
    }

    return errors;
  },
};
